import Col from "antd/lib/col";
import styled from "styled-components";

export const StyledCol = styled(Col)`
  color: rgba(0, 0, 0, 0.65);
  //font-family: "PingFang SC";
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;

  &.content {
    color: rgba(0, 0, 0, 0.45);
  }

  &.alignRight {
    text-align: right;
  }
`;

export const StyledOptionWrapper = styled.div`
  padding-bottom: 8px;
  border-bottom: 2px solid #979797;
  &:hover {
    border: none;
  }
`;
